import styles from './Form.module.css';
import imgBueroreinigung from './imgBueroreinigung.png'
import imgVerkaufsflaechenreinigung from './imgVerkaufsflaechenreinigung.png'
import imgTreppenhausreinigung from './imgTreppenhausreinigung.png'
import imgAfterEventReinigung from './imgAfterEventReinigung.png'
import imgGlasreinigung from './imgGlasreinigung.png'
import imgBauendreinigung from './imgBauendreinigung.png'
import imgPraxenreinigung from './imgPraxenreinigung.png'
import imgGrosskuechenreinigung from './imgGrosskuechenreinigung.png'
import {Bounce} from "react-awesome-reveal";
import React, {useState} from "react";
import {ScrollPanel} from "primereact/scrollpanel";



function Form(props) {

        const [selectedItemIndex, setSelectedItemIndex] = useState(null);

        const [items, setItems] = useState([
                {
                        label: 'Büro-',
                        service: 'Reinigung',
                        img: imgBueroreinigung,
                        text: 'Sauberkeit, die man spürt – schon während wir noch bei Ihnen sind. Unsere Teams sorgen nicht nur für glänzende Oberflächen, sondern für ein Arbeitsumfeld, das inspiriert. Am Ende bleibt mehr als Sauberkeit zurück: ein Raumklima, das Konzentration, Motivation und Wohlbefinden fördert.'
                },
                {
                        label: 'Verkaufsflächen-',
                        service: 'Reinigung',
                        img: imgVerkaufsflaechenreinigung,
                        text: 'Ein erster Eindruck, der bleibt – und glänzt. Verkaufsräume sind Ausdruck Ihrer Marke. Mit unserer professionellen Reinigung sorgen wir dafür, dass Ihre Flächen nicht nur sauber, sondern einladend und vertrauenswürdig wirken. Ein gepflegtes Ambiente zieht Kunden an – zuverlässig, regelmäßig und genau dann, wenn es für Sie passt.'
                },
                {
                        label: 'Treppenhaus-',
                        service: 'Reinigung',
                        img: imgTreppenhausreinigung,
                        text: 'Der erste Eindruck beginnt bereits beim Betreten des Gebäudes. Das Treppenhaus vermittelt Besuchern sofort ein Gefühl für Ihr Unternehmen – und dieser Eindruck bleibt. Mit unserer sorgfältigen Treppenhausreinigung sorgen wir für einen sauberen, gepflegten und einladenden Empfangsbereich.'
                },
                {
                        label: 'Event-',
                        service: 'Reinigung',
                        img: imgAfterEventReinigung,
                        text: 'Wo gefeiert wird, bleibt auch etwas zurück – wir kümmern uns darum. Ob private Feier oder großes Firmenevent: Jede Veranstaltung hinterlässt Spuren. Unser Team sorgt dafür, dass alles wieder so aussieht, als wäre nichts gewesen. So können Sie sich entspannt zurücklehnen und sich wieder auf das Wesentliche konzentrieren.'
                },
                {
                        label: 'Glas-',
                        service: 'Reinigung',
                        img: imgGlasreinigung,
                        text: 'Glas prägt den Charakter eines Gebäudes. Strahlend saubere Fenster schaffen Transparenz, lassen Architektur wirken und vermitteln Professionalität. Mit unserer gründlichen Glasreinigung sorgen wir für ein helles, streifenfreies Ambiente, das Vertrauen schafft und Räume optisch öffnet.'
                },
                {
                        label: 'Bauend-',
                        service: 'Reinigung',
                        img: imgBauendreinigung,
                        text: 'Auf Baustellen entstehen Staub, Schmutz und Rückstände. Wir sorgen dafür, dass sich Baustaub nicht im gesamten Gebäude verteilt und alle Flächen bereit für den nächsten Arbeitsschritt sind. Mit unserer professionellen Bauendreinigung schaffen wir Ordnung, Sauberkeit und optimale Bedingungen für den finalen Projektabschluss.'
                },
                {
                        label: 'Praxen-',
                        service: 'Reinigung',
                        img: imgPraxenreinigung,
                        text: 'In medizinischen Einrichtungen hat Sauberkeit eine besondere Bedeutung. Wo täglich Patienten betreut werden, muss Hygiene auf höchstem Niveau selbstverständlich sein. Vom Empfang über Verwaltungsbereiche bis hin zu sensiblen Behandlungsräumen sorgen wir für eine Reinigung, die weit über das Übliche hinausgeht.'
                },
                {
                        label: 'Großküchen-',
                        service: 'Reinigung',
                        img: imgGrosskuechenreinigung,
                        text: 'Für Küchen und Großküchen gelten seit 1995 die strengen Vorgaben des europäischen HACCP‑Systems. Wir stellen sicher, dass Ihre Arbeitsumgebung jederzeit hygienisch einwandfrei bleibt. Verlassen Sie sich auf uns, wenn es darum geht, Ihre Küche sauber, sicher und normgerecht zu halten.'
                }
        ]);

        const ITEMOLD = (props) => (
            <div className={styles.item + " md:col-3 col-6 flex align-items-center justify-content-center"} style={{height: '350px'}}>
                    {selectedItemIndex != props.index && (
                        <div
                            style={{padding: 10}}
                            onMouseEnter={() => setSelectedItemIndex(props.index)}
                            onClick={() => setSelectedItemIndex(props.index)}>
                                <div>
                                        <div style={{textAlign: 'center'}}>
                                                <img className={styles.itemImage} src={props.img}/>
                                                <div className={styles.itemLabel}>
                                                        {props.label}
                                                        <br/>
                                                        {props.service}
                                                </div>
                                        </div>
                                </div>
                        </div>
                    )}

                    {selectedItemIndex == props.index && (
                        <ScrollPanel style={{ width: '100%', height: '330px' }}>

                                <div className={styles.scrollBar} onClick={() => setSelectedItemIndex(props.index)}>
                                        <Bounce>
                                                <div className={styles.itemLabel} style={{paddingBottom: 10, fontWeight: 'bold'}}>
                                                        {props.label}
                                                        <br/>
                                                        {props.service}
                                                </div>
                                                <div style={{fontSize: 14, textAlign: 'left'}}>{props.text}</div>
                                        </Bounce>
                                </div>
                        </ScrollPanel>

                    )}
            </div>
        )

        const ITEM = (props) => (
            <div className={styles.item + " md:col-3 col-6"} style={{height: '350px'}}>
                    {selectedItemIndex != props.index && (
                        <div
                            style={{height: '350px', backgroundImage: 'url("' + props.img + '")', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}
                            onClick={() => setSelectedItemIndex(props.index)}>
                                <div>
                                        <div style={{textAlign: 'center'}}>
                                                <div style={{height: 250}}></div>
                                                <div className={styles.itemLabel} style={{background: 'rgba(241,245,248,0.75)', margin: 15, fontWeight: "bold"}}>
                                                        {props.label}
                                                        <br/>
                                                        {props.service}
                                                </div>
                                        </div>
                                </div>
                        </div>
                    )}

                    {selectedItemIndex == props.index && (
                        <ScrollPanel style={{ width: '100%', height: '330px' }}>
                                <div className={styles.scrollBar} onClick={() => setSelectedItemIndex(props.index)}>
                                        <Bounce>
                                                <div className={styles.itemLabel} style={{paddingBottom: 10, fontWeight: 'bold'}}>
                                                        {props.label}
                                                        <br/>
                                                        {props.service}
                                                </div>
                                                <div style={{fontSize: 14, textAlign: 'left', paddingBottom: 20}}>{props.text}</div>
                                        </Bounce>
                                </div>
                        </ScrollPanel>

                    )}
            </div>
        )

  return (
      <div ref={props.childRef} className={styles.root}>

              <div style={{background: '#276A9F'}}>
                      <center>
                              <div className={styles.header}>Unser Service</div>
                      </center>
              </div>
              <div className="wrapperSlim">
                      <center>
                              <div style={{
                                      background: '#276A9F'
                                      , height: 10
                                      , borderRadius: 10
                                      , width: '15%'
                                      , margin: '30px 0px 30px 0px'
                              }}/>
                              <div className={styles.text}>Wir bringen unseren Service auf das für Sie perfekte Maß. Bei jedem Auftrag stehen Ihre Wünsche im Mittelpunkt. Durch die Berücksichtigung individueller Anforderungen konnten wir unsere Kompetenzen stetig erweitern und mit jedem Projekt wachsen.</div>

                      </center>
                      <br/>

                      <div className="grid grid-nogutter" style={{border: 'solid 1px #F1F5F8'}}>
                              {items.map( (item, index) => (
                                  <ITEM
                                      index={index}
                                      label={item.label}
                                      service={item.service}
                                      img={item.img}
                                      text={item.text}
                                  />
                              )) }
                      </div>
              </div>
      </div>
  );
}

export default Form;
